import { ArrowDropDown } from '@mui/icons-material';
import CallEndOutlinedIcon from '@mui/icons-material/CallEndOutlined';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import apiManagerRoom from 'api/manager-meeting';
import apiManagerUser from 'api/manager-users';
import { IconClose, IconDelete } from 'assets/icons';
import IconLogo from 'assets/icons/IconLogo';
import { DIALOG_ID } from 'components/Dialog/constant';
import { TooltipCC } from 'components/common';
import { PATH_ROOT } from 'constants/api';
import { FUNCTIONS } from 'constants/roles';
import { useMenuCC } from 'hooks';
import moment from 'moment';
import { setIsChangePeriod } from 'pages/manager-meeting/modelPeriodSlice';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCloseModal } from 'store/modal/modalSlice';
import { checkFunctionHaveCode } from 'store/user/functions';
import { selectCurrentUserFunctions } from 'store/selectors';
import { TOAST_DEFAULT } from 'constants/toast';
import {
    removeLoadingButtonDialogConfirm,
    setCloseDialogCC,
    setOpenDialogCC,
    toastError,
    toastSuccess,
    toastWarning,
} from 'utils/helpers';
import { ReactComponent as StatisticsIcon } from 'assets/svg/StatisticsIcon.svg';
import 'pages/manager-meeting/detailMeeting.css';
import { IconCancelCalendar, IconCopy, IconUpdate } from './IconManagerMeeting';
import { useResponsivePixel } from './useResponsivePixel';

export const ActionButton = ({
    t,
    meetingCurrent,
    inviteeStatus,
    handleAccept,
    handleReject,
    userName,
    navigate,
    restoreRoom,
    cancelRoom,
    deleteRoom,
    stateInvite,
    getRoom,
    roomIdByURL,
    startTimeRoom
}) => {
    console.log('userName', userName, meetingCurrent)
    const dispatch = useDispatch();
    const { mdPixel } = useResponsivePixel();
    const { open, anchorEl, setAnchorEl } = useMenuCC();
    const handleClose = (_) => setAnchorEl(false);
    const functions = useSelector(selectCurrentUserFunctions);
    const canEdit = checkFunctionHaveCode(functions, FUNCTIONS.MANAGE_MEETING_SCHEDULE_EDIT)

    const endRoom = (data) => {
        return apiManagerRoom.updateEndRoom(data);
    };

    const handleModalRestoreRoom = () => {
        restoreRoom(meetingCurrent?.roomId)
            .then((r) => {
                if (r.status === 200) {
                    toastSuccess(t('subTabCancelSystem.toast.restoreSuccess'));
                    dispatch(setCloseModal());
                    navigate(`${PATH_ROOT}/manager-meeting`);
                }
            })
            .catch((error) => {
                if (error.response.data.detail === 'ROOM_IS_OVER') {
                    toastWarning(t('subTabCancelSystem.toast.restoreFail'));
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                }
            });
    };

    const handleActionConfirmCancel = () => {
        cancelRoom(meetingCurrent?.roomId)
            .then((r) => {
                if (r?.status === 200) {
                    toastSuccess(t('toast.cancelMeetSuccess'));
                    dispatch(setCloseModal());
                    navigate(`${PATH_ROOT}/manager-meeting`);
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                }
            })
            .catch((error) => {
                if (error?.response?.data?.detail === 'ROOM_IS_STARTED') {
                    toastWarning(t('toast.cancelMeetError'));
                }
                if (error?.response?.data?.detail === 'ROOM_IS_DELETED') {
                    toastWarning(t('toast.cancelMeetDeletedError'));
                    setTimeout(() => {
                        navigate(`${PATH_ROOT}/manager-meeting`);
                    }, 3000);
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                }
            });
    };

    const handleActionConfirmUpdate = (type) => {
        if (type === 'a') {
            dispatch(setIsChangePeriod(1));
            navigate(`${PATH_ROOT}/manager-meeting/schedule-meeting/update?roomId=${meetingCurrent.roomId}`);
        } else {
            dispatch(setIsChangePeriod(2));
            navigate(`${PATH_ROOT}/manager-meeting/schedule-meeting/update?roomId=${meetingCurrent.parentRoomId}`);
        }
    };

    const handleConfirm = () => {
        if (meetingCurrent?.isPeriod) {
            setOpenDialogCC({
                id: DIALOG_ID.CONFIRM_UPDATE,
                props: {
                    tsStart: moment(meetingCurrent?.tsStart).unix(),
                    roomName: meetingCurrent?.roomName,
                    handleActionConfirmUpdate: handleActionConfirmUpdate,
                },
            });
        } else {
            navigate(`${PATH_ROOT}/manager-meeting/schedule-meeting/update?roomId=${meetingCurrent?.roomId}`);
        }
    };

    const handleDelete = (meeting) => {
        let contentDelete = (
            <>
                <div className="col-md-12">
                    {t('room.pop-up.delete.text1')} <span style={{ fontWeight: '700' }}>{meeting.roomName}</span>?
                </div>
                <div className="col-md-12">{t('room.pop-up.delete.text2')}</div>
            </>
        );

        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t('room.pop-up.delete.title'),
                contentText: contentDelete,
                isDisableLoadingButton: true,
                onClick: () => {
                    removeLoadingButtonDialogConfirm();
                    setCloseDialogCC();
                    handleActionConfirmDeleteRoom(meetingCurrent);
                },
            },
        });
    };

    const handleActionConfirmDeleteRoom = (meeting) => {
        deleteRoom(meeting.roomId)
            .then((r) => {
                if (r?.status === 200) {
                    toastSuccess(t('toast.deleteMeetSuccess'));
                    navigate(`${PATH_ROOT}/manager-meeting`);
                    // props?.setReload(moment())
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                }
            })
            .catch((error) => {
                if (error?.response?.data?.detail === 'ROOM_IS_STARTED') {
                    toastWarning(t('toast.deleteMeetError'));
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                }
            });
        // props?.setReload(moment())
    };

    const checkLimitMeeting = () => {
        return apiManagerUser.checkLimitMeeting(roomIdByURL);
    };

    const handleJoinMeetByVMP = () => {
        checkLimitMeeting()
            .then((res) => {
                    if(res?.startMeeting){
                        // Check if the meeting can be started yet -> current moment must be between start and end time of meeting
                        if (meetingCurrent.isInstant !== 1) {
                            if (meetingCurrent.isPeriod === 'yes') {
                                if (
                                    moment(meetingCurrent.start) >= moment().startOf('days') &&
                                    moment(meetingCurrent.start) <= moment().endOf('days') &&
                                    moment() <= moment(meetingCurrent.end)
                                ) {
                                    getRoom(roomIdByURL)
                                        .then((res) => {
                                            if (res.status === 200) {
                                                if (res.data[0].type === 'not_start')
                                                    window.open(`${meetingCurrent.link}`);
                                                else if (res.data[0].type === 'end')
                                                    toastWarning(t('toast.meetingAreadyEnded'));
                                                else {
                                                    // toastWarning(t('toast.meetingAreadyStarted'))
                                                    window.open(`${meetingCurrent.link}`);
                                                }
                                            }
                                        })
                                        .catch((error) => { });
                                } else {
                                    toastWarning(t('toast.notYetTimeToJoin'));
                                }
                            } else window.open(`${meetingCurrent.link}`);
                        } else window.open(`${meetingCurrent.link}`);
                    }else{
                        if(res?.isHostMeeting){
                            setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING_HOST })
                        }else{
                            setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING })
                        }
                    }
            })
            .catch((err) => {
                console.log('Error: ', err);
            });
    };

    if (!mdPixel) {
        return (
            <div>
                <Button
                    variant="text"
                    id="meet-more"
                    aria-controls={open ? 'meet-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    endIcon={<ArrowDropDown />}
                >
                    {t('actions.option')}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'meet-more',
                    }}
                >
                    
                    <MenuItem sx={{ display: { xs: 'block', sm: 'none' } }}>{t('mnMeeting.joinNow')}</MenuItem>
                    {(meetingCurrent?.type === 'progress' ||
                        (meetingCurrent?.type === 'not_start' &&
                            moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0) ||
                        meetingCurrent?.isInstant === 1) && (
                            <MenuItem onClick={() => handleJoinMeetByVMP()}>{t('actions.joinButtonText')}</MenuItem>
                        )}
                    {(meetingCurrent?.userHostId === userName ||
                        meetingCurrent?.participant?.find((person) => person?.username === userName)?.role === 'host' ||
                        meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                        'coHost') &&
                        meetingCurrent?.type === 'end' && (
                            <MenuItem
                                onClick={() =>
                                    navigate(`${PATH_ROOT}/manager-meeting/detail-meeting/${meetingCurrent?.roomId}/statistics`)
                                }
                            >
                                {t('actions.statistics')}
                            </MenuItem>
                        )}
                    {meetingCurrent?.type === 'not_start' &&
                        meetingCurrent?.isTrash === 0 &&
                        userName === meetingCurrent?.userHostId &&
                        moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0 && (
                            <MenuItem onClick={handleConfirm}>{t('tooltip.editMeeting')}</MenuItem>
                        )}
                    {meetingCurrent?.userHostId === userName && (
                        <MenuItem
                            onClick={() =>
                                navigate(`${PATH_ROOT}/manager-meeting/schedule-meeting/copy?roomId=${meetingCurrent?.roomId}`)
                            }
                        >
                            {t('actions.btnCopyRoom')}
                        </MenuItem>
                    )}
                    {meetingCurrent?.isTrash === 1 && userName === meetingCurrent.userHostId && (
                        <MenuItem
                            onClick={() => {
                                setOpenDialogCC({
                                    id: DIALOG_ID.CONFIRM,
                                    props: {
                                        title: t('breadcrumb.title-restore-popup'),
                                        contentText:
                                            t('breadcrumb.content-restore-popup') +
                                            ' ' +
                                            meetingCurrent?.roomName +
                                            '?',
                                        onClick: () => {
                                            removeLoadingButtonDialogConfirm();
                                            setCloseDialogCC();
                                            handleModalRestoreRoom();
                                        },
                                    },
                                });
                            }}
                        >
                            {t('actions.restore')}
                        </MenuItem>
                    )}
                    {meetingCurrent?.type === 'not_start' &&
                        meetingCurrent?.isTrash === 0 &&
                        userName === meetingCurrent?.userHostId &&
                        moment(meetingCurrent.end).diff(moment(), 'minutes') >= 0 && (
                            <MenuItem
                                onClick={() => {
                                    let content = (
                                        <>
                                            <div className="col-md-12">
                                                {t('room.pop-up.cancel.text1')}{' '}
                                                <span style={{ fontWeight: '700' }}>{meetingCurrent?.roomName}</span>?
                                            </div>
                                            <div className="col-md-12">{t('room.pop-up.cancel.text2')}</div>
                                        </>
                                    );

                                    setOpenDialogCC({
                                        id: DIALOG_ID.CONFIRM,
                                        props: {
                                            title: t('room.pop-up.cancel.title'),
                                            titleActions: t('room.pop-up.cancel.save'),
                                            contentText: content,
                                            isDisableLoadingButton: true,
                                            onClick: () => {
                                                removeLoadingButtonDialogConfirm();
                                                setCloseDialogCC();
                                                handleActionConfirmCancel();
                                            },
                                        },
                                    });
                                }}
                            >
                                {t('tooltip.cancelMeeting')}
                            </MenuItem>
                        )}
                    {meetingCurrent?.type === 'not_start' &&
                        meetingCurrent?.isTrash === 0 &&
                        userName === meetingCurrent?.userHostId &&
                        moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0 && (
                            <MenuItem onClick={() => handleDelete(meetingCurrent)}>
                                {t('tooltip.deleteMeeting')}
                            </MenuItem>
                        )}
                    {meetingCurrent?.type === 'progress' &&
                        (meetingCurrent?.userHostId === userName ||
                            meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                            'host' ||
                            meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                            'coHost') && (
                            <MenuItem
                                onClick={
                                    () =>
                                        setOpenDialogCC({
                                            id: DIALOG_ID.CONFIRM,
                                            props: {
                                                title: t('room.pop-up.end.title'),
                                                contentText: t('room.pop-up.end.text1'),
                                                isDisableLoadingButton: true,
                                                onClick: () => {
                                                    endRoom({
                                                        roomId: meetingCurrent?.roomId,
                                                        parentRoomId: meetingCurrent?.parentRoomId,
                                                    })
                                                        .then((r) => {
                                                            if (r.status === 200 && r.data?.type === 'progress') {
                                                                toastSuccess(t('toast.endMeetSuccess'));
                                                            } else if (r.status === 200 && r.data?.type === 'end') {
                                                                toastWarning(t('toast.endedMeeting'));
                                                            } else {
                                                                toastError(t(TOAST_DEFAULT.ERROR));
                                                            }
                                                        })
                                                        .catch((e) => {
                                                            console.log(e);
                                                        })
                                                        .finally(() => {
                                                            setCloseDialogCC();
                                                        });
                                                },
                                            },
                                        })
                                    // dispatch(
                                    //     setOpenModal({
                                    //         modal: (
                                    //             <ModelEndRoom
                                    //                 title={t('room.pop-up.end.title')}
                                    //                 actionText={t('room.pop-up.end.save')}
                                    //                 actionCancelText={t('room.pop-up.end.cancel')}
                                    //                 roomId={meetingCurrent?.roomId}
                                    //                 parentRoomId={meetingCurrent?.parentRoomId}
                                    //                 open={true}
                                    //                 handleClose={function () {
                                    //                     dispatch(setCloseModal());
                                    //                 }}
                                    //                 // setTriggerReload={props?.setReload}
                                    //                 t={t}
                                    //             />
                                    //         ),
                                    //     }),
                                    // )
                                }
                            >
                                {t('actions.finish')}
                            </MenuItem>
                        )}
                    {meetingCurrent?.participant?.find((par) => par.username === userName) &&
                        userName !== meetingCurrent?.userHostId &&
                        meetingCurrent?.isTrash === 0 &&
                        meetingCurrent?.type === 'not_start' &&
                        moment(meetingCurrent?.end).diff(moment().startOf('minute'), 'minutes') >= 0 && (
                            <>
                                <MenuItem
                                    onClick={() => {
                                        setAnchorEl(null);
                                        handleAccept();
                                    }}
                                >
                                    {t('modalDetail.Access')}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setOpenDialogCC({
                                            id: DIALOG_ID.REJECT_INVITE,
                                            props: {
                                                title: t('room.pop-up.reject.title'),
                                                nameRoom: meetingCurrent?.roomName,
                                                roomId: meetingCurrent?.parentRoomId || meetingCurrent.roomId,
                                                onReject: () => {
                                                    setAnchorEl(null);
                                                    handleReject();
                                                },
                                            },
                                        });
                                    }}
                                >
                                    {t('room.pop-up.reject.save')}
                                </MenuItem>
                            </>
                        )}

                    <MenuItem onClick={() => navigate(`${PATH_ROOT}/manager-meeting`)}>{t('actions.closePage')}</MenuItem>
                </Menu>
            </div>
        );
    }

    return (
        <Box display={'flex'} alignItems={'center'} columnGap={1.5}>
            {(meetingCurrent?.type === 'progress' ||
                (meetingCurrent?.type === 'not_start' && moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0) ||
                (meetingCurrent?.type === 'end' && moment()?.unix() < moment(meetingCurrent?.end).unix()) ||
                meetingCurrent?.isInstant === 1) &&
                meetingCurrent?.isTrash === 0 ? (
                <TooltipCC title={t('actions.joinConference')}>
                    <Button
                        onClick={() => handleJoinMeetByVMP()}
                        size="large"
                        startIcon={<IconLogo color={'white'} style={{ marginTop: 2 }} width={24} height={24} />}
                    >
                        {t('actions.joinButtonText')}
                    </Button>
                </TooltipCC>
            ) : (
                <></>
            )}
            <Fragment>
                {(meetingCurrent?.userHostId === userName ||
                    meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                    'host' ||
                    meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                    'coHost') &&
                    meetingCurrent?.type === 'end' ? (
                    <TooltipCC title={t('actions.statistics')}>
                        <Button
                            className="margin-left-10px"
                            variant="outlined"
                            size="small"
                            // style={{ color: '#004E7A', borderColor: '#004E7A' }}
                            startIcon={<StatisticsIcon />}
                            onClick={() => {
                                navigate(`${PATH_ROOT}/manager-meeting/details/${meetingCurrent?.roomId}/statistics`);
                            }}
                        >
                            <span style={{ fontWeight: '700' }}>{t('actions.statistics')}</span>
                        </Button>
                    </TooltipCC>
                ) : (
                    <></>
                )}
                {(canEdit && meetingCurrent?.type === 'not_start' &&
                    meetingCurrent?.isTrash === 0 &&
                    userName === meetingCurrent?.userHostId &&
                    moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0) && (
                        <Fragment>
                            <TooltipCC title={t('tooltip.editMeeting')}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleConfirm}
                                    className="margin-left-10px"
                                    startIcon={<IconUpdate />}
                                >
                                    <span>{t('tooltip.editMeeting')}</span>
                                </Button>
                            </TooltipCC>
                        </Fragment>
                    )}
                {(canEdit && meetingCurrent?.userHostId === userName) ? (
                    <TooltipCC title={t('actions.btnCopyRoom')}>
                        <Button
                            className="margin-left-10px"
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                navigate(
                                    `${PATH_ROOT}/manager-meeting/schedule-meeting/copy?roomId=${meetingCurrent?.roomId}`,
                                );
                            }}
                            startIcon={<IconCopy />}
                        >
                            <span>{t('actions.btnCopyRoom')}</span>
                        </Button>
                    </TooltipCC>
                ) : (
                    <></>
                )}
                {(canEdit && meetingCurrent?.isTrash === 1 &&
                    userName === meetingCurrent.userHostId &&
                    moment(meetingCurrent?.start).diff(moment().startOf('minute'), 'minutes') > 0) ? (
                    <TooltipCC title={t('actions.restore')}>
                        <Button
                            className="margin-left-10px"
                            style={{ marginLeft: '10px' }}
                            tabIndex={0}
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                setOpenDialogCC({
                                    id: DIALOG_ID.CONFIRM,
                                    props: {
                                        title: t('breadcrumb.title-restore-popup'),
                                        contentText:
                                            t('breadcrumb.content-restore-popup') +
                                            ' ' +
                                            meetingCurrent?.roomName +
                                            '?',
                                        onClick: () => {
                                            removeLoadingButtonDialogConfirm();
                                            setCloseDialogCC();
                                            handleModalRestoreRoom();
                                        },
                                    },
                                });
                            }}
                        >
                            <span>{t('actions.restore')}</span>
                        </Button>
                    </TooltipCC>
                ) : (
                    <></>
                )}
                {(canEdit && meetingCurrent?.type === 'not_start' &&
                    meetingCurrent?.isTrash === 0 &&
                    userName === meetingCurrent?.userHostId &&
                    moment(meetingCurrent.end).diff(moment(), 'minutes') >= 0) && (
                        <TooltipCC title={t('actions.cancelMeeting')}>
                            <Button
                                className="margin-left-10px"
                                variant="outlined"
                                size="small"
                                startIcon={<IconCancelCalendar />}
                                onClick={() => {
                                    let content = (
                                        <>
                                            <div className="col-md-12">
                                                {t('room.pop-up.cancel.text1')}{' '}
                                                <span style={{ fontWeight: '700' }}>
                                                    {meetingCurrent?.roomName}
                                                </span>
                                                ?
                                            </div>
                                            <div className="col-md-12">{t('room.pop-up.cancel.text2')}</div>
                                        </>
                                    );

                                    setOpenDialogCC({
                                        id: DIALOG_ID.CONFIRM,
                                        props: {
                                            title: t('room.pop-up.cancel.title'),
                                            contentText: content,
                                            onClick: () => {
                                                removeLoadingButtonDialogConfirm();
                                                setCloseDialogCC();
                                                handleActionConfirmCancel();
                                            },
                                        },
                                    });
                                }}
                            >
                                <span>{t('tooltip.cancelMeeting')}</span>
                            </Button>
                        </TooltipCC>
                    )}

                {(canEdit && meetingCurrent?.type === 'not_start' &&
                    meetingCurrent?.isTrash === 0 &&
                    userName === meetingCurrent?.userHostId &&
                    moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0) && (
                        <Fragment>
                            <TooltipCC title={t('tooltip.deleteMeeting')}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleDelete(meetingCurrent)}
                                    className="margin-left-10px"
                                    startIcon={<IconDelete />}
                                >
                                    <span>{t('tooltip.deleteMeeting')}</span>
                                </Button>
                            </TooltipCC>
                        </Fragment>
                    )}
                {(canEdit && meetingCurrent?.type === 'progress' &&
                    (meetingCurrent?.userHostId === userName ||
                        meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                        'host' ||
                        meetingCurrent?.participant?.find((person) => person?.username === userName)?.role ===
                        'coHost')) && (
                        <TooltipCC title={t('actions.finishMeeting')}>
                            <Button
                                className="margin-left-10px"
                                variant="outlined"
                                size="small"
                                startIcon={<CallEndOutlinedIcon />}
                                onClick={
                                    () =>
                                        setOpenDialogCC({
                                            id: DIALOG_ID.CONFIRM,
                                            props: {
                                                title: t('room.pop-up.end.title'),
                                                contentText: t('room.pop-up.end.text1'),
                                                isDisableLoadingButton: true,
                                                onClick: () => {
                                                    endRoom({
                                                        roomId: meetingCurrent?.roomId,
                                                        parentRoomId: meetingCurrent?.parentRoomId,
                                                    })
                                                        .then((r) => {
                                                            if (
                                                                r.status === 200 &&
                                                                r.data?.type === 'progress'
                                                            ) {
                                                                toastSuccess(t('toast.endMeetSuccess'));
                                                            } else if (
                                                                r.status === 200 &&
                                                                r.data?.type === 'end'
                                                            ) {
                                                                toastWarning(t('toast.endedMeeting'));
                                                            } else {
                                                                toastError(t(TOAST_DEFAULT.ERROR));
                                                            }
                                                        })
                                                        .catch((e) => {
                                                            console.log(e);
                                                        })
                                                        .finally(() => {
                                                            setCloseDialogCC();
                                                        });
                                                },
                                            },
                                        })
                                    // dispatch(
                                    //     setOpenModal({
                                    //         modal: (
                                    //             <ModelEndRoom
                                    //                 title={t('room.pop-up.end.title')}
                                    //                 actionText={t('room.pop-up.end.save')}
                                    //                 actionCancelText={t('room.pop-up.end.cancel')}
                                    //                 roomId={meetingCurrent?.roomId}
                                    //                 parentRoomId={meetingCurrent?.parentRoomId}
                                    //                 open={true}
                                    //                 handleClose={function () {
                                    //                     dispatch(setCloseModal());
                                    //                 }}
                                    //                 // setTriggerReload={props?.setReload}
                                    //                 t={t}
                                    //             />
                                    //         ),
                                    //     }),
                                    // )
                                }
                            >
                                <span>{t('actions.finish')}</span>
                            </Button>
                        </TooltipCC>
                    )}
                {meetingCurrent?.participant?.find((par) => par.username === userName) &&
                    userName !== meetingCurrent?.userHostId &&
                    meetingCurrent?.isTrash === 0 &&
                    meetingCurrent?.type === 'not_start' &&
                    moment(meetingCurrent?.end).diff(moment().startOf('minute'), 'minutes') >= 0 && (
                        <div className="d-flex justify-between ">
                            {/* <div style={{ alignSelf: 'center' }}>{t('modalDetail.join')}</div> */}
                            {/* {stateInvite?.message && inviteeStatus == 0 && (
                            <div
                                style={{
                                    width: '44%',
                                    alignSelf: 'center',
                                }}
                            >
                                {t('room.pop-up.reject.reason')} {stateInvite?.message}
                            </div>
                        )} */}
                            <div>
                                <Button
                                    onClick={handleAccept}
                                    style={{
                                        cursor: inviteeStatus === 1 ? 'not-allowed' : 'pointer',
                                        marginRight: 12,
                                        marginLeft: 12,
                                    }}
                                    disabled={inviteeStatus === 1}
                                    variant="outlined"
                                    size="medium"
                                >
                                    {t('modalDetail.Access')}
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={() => {
                                        setOpenDialogCC({
                                            id: DIALOG_ID.REJECT_INVITE,
                                            props: {
                                                title: t('room.pop-up.reject.title'),
                                                nameRoom: meetingCurrent?.roomName,
                                                roomId: meetingCurrent?.parentRoomId || meetingCurrent.roomId,
                                                onReject: () => {
                                                    handleReject();
                                                },
                                            },
                                        });
                                    }}
                                    style={{ cursor: inviteeStatus === 0 ? 'not-allowed' : 'pointer' }}
                                    disabled={inviteeStatus === 0}
                                >
                                    {t('room.pop-up.reject.save')}
                                </Button>
                            </div>
                        </div>
                    )}
            </Fragment>
            <TooltipCC title={t('actions.closePage')}>
                <Button
                    className='stroke'
                    variant="outlined"
                    size="small"
                    startIcon={<IconClose />}
                    onClick={() => {
                        navigate(`${PATH_ROOT}/manager-meeting`);
                    }}
                >
                    <div style={{ fontWeight: '700' }}>{t('actions.closePage')}</div>
                </Button>
            </TooltipCC>
        </Box>
    );
};
